import { TableCellTypography } from '@aibees/shared/components';
import { Typography } from '@mui/material';
import { memo } from 'react';
import { getEnrichmentSearchUrl } from '../../utils';
import * as Styled from './styles';
import type { EnrichmentFileNameProps as Props } from './types';

export const EnrichmentFileName = memo(({ className, item }: Props) => {
  if (!item.name) return null;
  const url = getEnrichmentSearchUrl(item);

  if (!url) {
    return (
      <Typography variant="body3" color="grey.800" fontWeight={400}>
        {item.name}
      </Typography>
    );
  }

  return (
    <Styled.StyledLink to={url} target="_blank" rel="noreferrer">
      <TableCellTypography item={item.name} color="grey.800" />
    </Styled.StyledLink>
  );
});

EnrichmentFileName.displayName = 'EnrichmentFileName';
